import {Pipe, PipeTransform} from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'datex'
})

export class DatexPipe implements PipeTransform {
  transform(value, format: string = ''): string {
    if (!value || value === '') {
      return '';
    }
    return moment(value).format(format);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipe/datex.pipe.ts